import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'huge-monorepo-teltonika-update-credentials-modal',
  standalone: true,
  imports: [CommonModule, MaterialModule, ReactiveFormsModule],
  templateUrl: './TeltonikaUpdateCredentialsModal.component.html',
  styleUrl: './TeltonikaUpdateCredentialsModal.component.scss',
})
export class TeltonikaUpdateCredentialsModalComponent {
  usernameControl: FormControl = new FormControl(null, [Validators.required]);
  passwordControl: FormControl = new FormControl(null, [Validators.required]);

  constructor(
    public dialogRef: MatDialogRef<TeltonikaUpdateCredentialsModalComponent>,
  ) { }

  closeModal(update: boolean) {
    if (update) {
      if (this.usernameControl.valid && this.passwordControl.valid) {
        this.dialogRef.close({ username: this.usernameControl.value, password: this.passwordControl.value });
      }
    }
    else {
      this.dialogRef.close();
    }
  }
}
